/**
 * The below file contains the vehicle category state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_VEHICLE_CATEGORY,
} from "redux/constants/VehicleCategory";

//Initial state
const initState = {
  // Keys for dropdown 
  vehicleCategories: [],
  isVehicleCategoryDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const vehicleCategory = (state = initState, action) => {
  switch (action.type) {
    //Cases for Vehicle Categories dropdown
    case SET_ALL_VEHICLE_CATEGORY:
      return {
        ...state,
        vehicleCategories: action.payload,
        isVehicleCategoryDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Vehicle Categories dropdown

    default:
      return state;
  }
};

export default vehicleCategory;
